<template>
  <section class="closefriend-hero h-100">
    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>
    <customer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></customer-menu>
    <header-menu @slideMenu="slideBar()"></header-menu>

    <div class="container-fluid mt-3">
      <div class="row justify-content-center">
        <div class="col-12 px-2 px-md-4" style="max-width: 1200px;">
          <!-- Header -->
          <div class="d-flex flex-wrap align-items-center justify-content-between mb-4 mt-2 px-1 gap-2">
            <div>
              <h5 class="text-white font-weight-700 mb-0 font-size-20">Recent Transactions</h5>
              <span class="text-muted font-size-12">{{ customerTransactions.length }} transactions</span>
            </div>
          </div>
          
          <div class="mt-2">
            <global-message></global-message>

              <div v-if="customerTransactions.length === 0 && !busy" class="text-center py-5">
                <p class="text-white font-size-16 mb-0" style="opacity: 0.5;">No transactions found</p>
              </div>

              <div v-infinite-scroll="loadMore"
                infinite-scroll-disabled="busy" infinite-scroll-distance="5"
                infinite-scroll-throttle-delay="1000"
                class="w-100 pb-5">
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-4 mb-3"
                    v-for="(customerTransaction, index) in customerTransactions" :key="index">
                    <div class="custom-card-transparent">
                      <div class="stella-card-header d-flex align-items-center justify-content-between">
                        <span class="stella-card-index">#{{ index + 1 }}</span>
                        <span class="stella-card-price">${{ customerTransaction.amount }}</span>
                      </div>
                      <div class="stella-card-body flex-grow-1">
                        <h6 class="stella-card-title">{{ customerTransaction.name }}</h6>
                        <p class="stella-card-desc mt-2 mb-0" style="color: rgba(255,255,255,0.5); word-break: break-all;">{{ customerTransaction.transactionId }}</p>
                      </div>
                      <div class="stella-card-footer d-flex align-items-center justify-content-between mt-auto">
                        <span class="stella-card-status" style="font-weight: 500;" :style="{ color: getStatusColorHex(customerTransaction.status) }">
                          <span class="status-dot" :style="{ backgroundColor: getStatusColorHex(customerTransaction.status) }"></span>
                          {{ camelCaseToSentence(customerTransaction.status) }}
                        </span>
                        <span class="font-size-12" style="color: rgba(255, 255, 255, 0.3);">
                          {{ customerTransaction.transactedAt | formatDateTime }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="busy && !isComplete" class="text-center w-100 py-3">
                  <div class="spinner-border text-light" role="status" style="opacity: 0.5;">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import { mapGetters } from "vuex";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import { camelCaseToSentence } from '@/common/Utils';
import CustomerMenu from "@/components/module/customer/shared/CustomerMenu";
import { SERVICE_PAYMENT } from "@/properties/micro-service";
import { igValidationMixin } from "@/mixin/ig-validation-mixin";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import infiniteScroll from 'vue-infinite-scroll'
import PendingCustomRequests from "@/components/module/customer/shared/PendingCustomRequests";
import CustomerPwaActionBar from "@/components/module/customer/shared/CustomerPwaActionBar";
import titleMixin from "../../../../mixin/title-mixin";

export default {
  name: 'RecentTransactionMobile',
  title: 'Recent transaction',
  components: {
    GlobalMessage, HeaderMenu,
    CustomerMenu, PendingCustomRequests, CustomerPwaActionBar
  },
  mixins: [igValidationMixin, titleMixin],
  data() {
    return {
      user: {},
      customerTransactions: [],
      showSlideBar: false,

      pageNumber: 0,
      noOfItems: 10,
      isComplete: false,
      busy: false
    }
  },
  created() {
    this.user = this.getUser();
  },
  methods: {
    ...mapGetters(['getUser']),
    camelCaseToSentence,
    getStatusColorHex(status) {
      const s = status ? status.toLowerCase() : '';
      if (s === 'success' || s === 'completed') return '#55EFC4';
      if (s === 'pending') return '#80CBFE';
      if (s === 'declined' || s === 'canceled' || s === 'failed') return '#FF4B81';
      return '#B8B8B8';
    },
    loadMore() {
      if (this.isComplete === true || this.busy) {
        return;
      }
      this.busy = true;
      let url = `${SERVICE_PAYMENT}/api/v1/customers/${this.user.id}/page?pageNumber=${this.pageNumber}&numberOfItems=${this.noOfItems}`;
      this.getData(url, (page) => {
        if (this.pageNumber === 0) {
          this.initIGValidity();
        }
        if (!page.empty) {
          this.customerTransactions.push(...page.content);
          this.pageNumber += 1;
        }
        this.isComplete = page.last;
        this.busy = false;
      })
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
  },
  directives: {
    infiniteScroll
  }
}
;
</script>

<style scoped>




.stella-card-index {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
}

.stella-card-price {
  font-size: 16px;
  font-weight: 700;
  color: #55EFC4;
}

.stella-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 4px;
}

.stella-card-desc {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.stella-card-status {
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}
</style>
